import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesReturns } from "../../constants";
import { ReturnRejectFormValues } from "../../returns.types";

export const requestRejectReturn = async (
  body: ReturnRejectFormValues
): Promise<void> => {
  return await instance.put(buildUrl(ApiRoutesReturns.RejectReturn), body);
};
